module.exports = __webpack_public_path__ + "img/search.1429f7a2.svg";